import React from 'react';
import { type IRecommendationContextShape } from '../../../types/recommendationTypes';

export const RecommendationWidgetContext = React.createContext<IRecommendationContextShape | null>(null);

export default RecommendationWidgetContext;
